import {
 login, logout, register, bindMobile,
} from '@/services/user';
import { getAuth, getUID, setAuth } from '@/utils';

const user = {
  state: {
    id: getUID() || 0,
    auth: getAuth() || '',
  },
  getters: {
    userId: state => state.id,
    auth: state => state.auth,
  },
  mutations: {
    SET_ID: (state, data) => {
      state.id = data;
    },
    SET_AUTH: (state, data) => {
      state.auth = data;
    },
  },
  actions: {
    updateAuth({ commit }) {
      const auth = getAuth();
      commit('SET_AUTH', auth);
      commit('SET_ID', getUID());
    },
    Login({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await login(payload.username, payload.password);
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve(data);
        } catch (e) {
          return reject(e);
        }
      });
    },
    BindMobile({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await bindMobile(
            payload.mobile,
            payload.smsCode,
          );
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve(data);
        } catch (e) {
          return reject(e);
        }
      });
    },
    Register({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await register(
            payload.mobile,
            payload.smsCode,
            payload.password,
            payload.passwordCheck,
          );
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve(data);
        } catch (e) {
          return reject(e);
        }
      });
    },
    Logout({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          await logout();
          commit('SET_ID', 0);
          commit('SET_AUTH', '');
          setAuth('');
          return resolve();
        } catch (e) {
          return reject(e);
        }
      });
    },
  },
};

export default user;
